import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectMyMfaDetails } from 'State/Redux/IdentityRedux';
import './MfaEnrollmentBanner.scss';

const MfaEnrollmentBanner = (): JSX.Element | null => {
   const myMfaDetails = useSelector(selectMyMfaDetails);
   const [dismissed, setDismissed] = useState(false);

   if (!myMfaDetails || dismissed) return null;

   const {
      totpEnrolledDate,
      smsEnrolledDate,
      enforcementDate,
      enforcementDateMessage,
   } = myMfaDetails;
   const isEnrolled = !!totpEnrolledDate || !!smsEnrolledDate;

   if (isEnrolled || !enforcementDate) return null;

   const enforcement = new Date(enforcementDate);
   if (new Date() >= enforcement) return null;

   const formattedDate = enforcement.toLocaleDateString('en-NZ', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
   });

   const bannerText =
      enforcementDateMessage ||
      `You have not enrolled in multi-factor authentication (MFA). Please enrol on or before ${formattedDate}.`;

   return (
      <div className="mfa-enrollment-banner">
         <i className="material-icons mfa-enrollment-banner__icon">warning</i>
         <span>{bannerText}</span>
         <button
            className="mfa-enrollment-banner__dismiss"
            onClick={(): void => setDismissed(true)}
            aria-label="Dismiss"
         >
            <i className="material-icons">close</i>
         </button>
      </div>
   );
};

export default MfaEnrollmentBanner;
